import React, { useContext, useEffect } from 'react'

import { Link } from 'react-router-dom'
import ReactGA from 'react-ga4'
import styled, { keyframes } from 'styled-components'

// hooks
import useFeaturedPosts from '../hooks/useFeaturedPosts'

// styled
import { RouterButton, Container, ListLink, SplitColumns, Text } from '../components/styled'

// components
import { AuthContext } from '../auth/AuthContext'
import MetaTags from '../components/MetaTags'

const shake = keyframes`
  0%, 100% { transform: rotate(0deg); }
  10% { transform: rotate(-3deg); }
  20% { transform: rotate(3deg); }
  30% { transform: rotate(-3deg); }
  40% { transform: rotate(3deg); }
  50% { transform: rotate(0deg); }
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1em;
`

const ShakingButton = styled(RouterButton)`
  animation: ${shake} 1s ease-in-out;
  animation-iteration-count: 1;
  animation-delay: 0s;
  animation-fill-mode: both;
  margin-bottom: 0;
  border-width: 3px;
`

const Posts = () => {
  const { anonymous, user } = useContext(AuthContext)
  const { loading, posts } = useFeaturedPosts()
  const [shakeKey, setShakeKey] = React.useState(0)

  useEffect(() => {
    window.previousLocation = window.location.pathname
    ReactGA.send({ hitType: 'pageview', page: '/posts' })
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setShakeKey(prev => prev + 1)
    }, 5000)
    return () => clearInterval(interval)
  }, [])

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <>
      <MetaTags title='Sortada.com' />
      <Container className='App'>
        <ButtonWrapper>
          {user && !anonymous
            ? <ShakingButton key={shakeKey} to='/add'>Add New Postulation</ShakingButton>
            : <ShakingButton key={shakeKey} to='/login'>Login To Create Your Own</ShakingButton>}
        </ButtonWrapper>
        <SplitColumns>
          <div>
            <ul>
              {posts.map(post => (
                <ListLink key={`${post.title}-list-link`}>
                  <Link to={`/postulation/${post.id}`}>{post.title}</Link>
                </ListLink>
              ))}
            </ul>
          </div>
          <div>
            <h2>What is Sortada?</h2>
            <Text>Sortada is a tool that uses rank choice voting to answer questions. If you're new to Sortada, click on one of our public sortadas to vote and view the results. Note that you need to vote to see the results. Drag and drop the candidates into the order you desire and then click vote. Happy sorting.</Text>
            <Text>Head over to our <Link to='/about'>about page</Link> for more help.</Text>
          </div>
        </SplitColumns>
      </Container>
    </>
  )
}

export default Posts
